{{{o.num_minimized}}} {{{o.Minimized}}}
<span class="unread-message-count {[ if (!o.num_unread) { ]} unread-message-count-hidden {[ } ]}" href="#">{{{o.num_unread}}}</span>
